import { signIn, signOut, onAuthStateChanged } from '../auth';
import { useState, useEffect, useCallback } from 'react';

export default function useAuth() {
  const [userDetail, setUserDetail] = useState(null);

  const setUser = (userDetail) => {
    setUserDetail(userDetail);
  };

  useEffect(() => {
    const unsubscribeAuthStateChanged = onAuthStateChanged(userDetail => {
      if (!userDetail) {
        setUserDetail(null);
      } else {
        setUser(userDetail);
      }
    });
    return () => {
      unsubscribeAuthStateChanged && unsubscribeAuthStateChanged();
    };
  }, []);

  const signInUser = useCallback(() => signIn(), []);
  const signOutUser = useCallback(() => signOut(), []);

  return [
    userDetail,
    signInUser,
    signOutUser,
  ];
}